import { IFeaturedImageGallery } from '@models/IFeaturedImageGallery';
import ImageLightBox from '@molecules/ImageLightBox/ImageLightBox';
import SoftLoadWrapper from '@molecules/SoftLoadWrapper/SoftLoadWrapper';
import useProductPageContentStore from '@state/ProductPageStore';
import classNames from 'classnames';

const FeaturedImageGallery = (props: IFeaturedImageGallery) => {
  const {
    featureTitle,
    primaryImage,
    secondaryImages = [],
    meta,
  } = useProductPageContentStore().productPageContent?.featuredImageGallery ||
  props;

  const contentIds = [
    primaryImage?.meta?.contentLink as string,
    ...(secondaryImages
      ?.map((image) => image.meta?.contentLink as string)
      .filter((link) => link !== undefined) ?? []),
  ];

  if (!primaryImage || secondaryImages?.length === 0) {
    return null;
  }

  return (
    <section
      className="component-padding bg-black-100 text-white"
      data-testid="CT-165-Featured-Image-Gallery"
    >
      <SoftLoadWrapper>
        <div className="flex w-full flex-col gap-10 text-center md:gap-24">
          {featureTitle && (
            <div className="container flex w-full items-center justify-center">
              <h2
                className="md:w-3/5"
                data-testid="CT-165-Featured-Image-Gallery-Title"
                data-epi-property-name={meta?.editHints?.featureTitle}
              >
                {featureTitle}
              </h2>
            </div>
          )}

          <div className="container flex flex-col items-center gap-4 md:flex-row">
            <div
              className="md:w-1/2"
              data-epi-property-name={meta?.editHints?.primaryImage}
            >
              <ImageLightBox
                contentIds={contentIds}
                {...primaryImage}
                showAuthorOnHover
                imageClasses="object-cover aspect-square h-full"
                dataTestId="CT-165-Featured-Image-Gallery-Primary-Image"
              />
            </div>
            <div
              className={classNames('md:w-1/2', {
                'grid grid-cols-2 gap-4': secondaryImages.length > 1,
              })}
              data-epi-property-name={meta?.editHints?.secondaryImages}
            >
              {secondaryImages.map((image, index) => (
                <ImageLightBox
                  key={`${image.image.desktop.url}-gallery-image`}
                  contentIds={contentIds}
                  {...image}
                  showAuthorOnHover
                  imageClasses="w-full h-auto object-cover aspect-square"
                  dataTestId={`CT-165-Featured-Image-Gallery-Image-${index}`}
                />
              ))}
            </div>
          </div>
        </div>
      </SoftLoadWrapper>
    </section>
  );
};

export default FeaturedImageGallery;
